import { IconButton, IconPencil, SwaggerHubIcon } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'
import { useNavigation } from 'react-router'

import { TooltipWrapper } from '~/components/TooltipWrapper'
import { useApiHubPlan } from '~/hooks/useApiHubPlan'

export interface EditContentButtonsProps {
  contentUrl?: string,
  shubUrl?: string,
}

export const EditContentButtons = ({
  contentUrl,
  shubUrl,
}: EditContentButtonsProps) => {
  const { t } = useTranslation()

  const { platformManaged } = useApiHubPlan() || {}
  
  const { location, state } = useNavigation()

  return (
    <>
      {contentUrl ? (
        <TooltipWrapper
          content={t('consumer.edit.buttons.manageContent.tooltip')}
          trigger="hover"
          defaultComp={
            <IconButton
              aria-label={t('consumer.edit.buttons.manageContent.tooltip')}
              icon={<IconPencil />}
              to={contentUrl}
              loading={location?.pathname === contentUrl && state === 'loading'}
              outline={true}
              size="s"
              className="dark:border-neutral-40 border-neutral-70"
            />
          }
          placement="bottom-end"
        />
      ) : null}
      {shubUrl ? (
        <TooltipWrapper
          content={platformManaged ? t('consumer.edit.buttons.editInSwaggerHub.tooltipApiHub') : t('consumer.edit.buttons.editInSwaggerHub.tooltip')}
          trigger="hover"
          defaultComp={
            <IconButton
              aria-label={platformManaged ? t('consumer.edit.buttons.editInSwaggerHub.tooltipApiHub') : t('consumer.edit.buttons.editInSwaggerHub.tooltip')}
              icon={<SwaggerHubIcon />}
              target="_blank"
              to={shubUrl}
              outline={true}
              size="s"
              className="dark:border-neutral-40 border-neutral-70"
            />
          }
          placement="bottom-end"
        />
      ) : null}
    </>
  )
}